import { FrameName } from "../config";
import SettlementEmptyTerrainTileEntity from "./SettlementEmptyTerrainTileEntity";

class SettlementEmpty11TerrainTileEntity extends SettlementEmptyTerrainTileEntity {
	public static readonly frameName = FrameName.SETTLEMENT_EMPTY11;
}

export default SettlementEmpty11TerrainTileEntity;
